// Updated Button.js with centered label
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../assets/css/Home.css";
import { useEffect, useState } from "react";
import { Row, Col, Card, CardHeader, CardBody } from "reactstrap";
import TreeIcon from "../assets/img/tree.svg"
import SetIcon from "../assets/img/set symbol.svg"
import "../assets/css/HomePageButton.css"
import { useLanguage } from "context/LanguageProvider";
import { sideBarLinks } from "./translation";

import {
  faTree,
  faProjectDiagram,
  faList,
  faTh,
  faHashtag,
  faArrowUp,
  faArrowDown,
  faPercent,
} from "@fortawesome/free-solid-svg-icons";

function Button({ label, onClick, showProgress = true, progress }) {
  const [isHovered, setIsHovered] = useState(false);

  const { selLanguage, toggleLanguage, isLoading } = useLanguage();


  const iconMap = {
    Graph: faProjectDiagram,
    List: faList,
    Array: faTh,
    Stack: faArrowUp,
    Queue: faArrowDown,
    HashTable: faHashtag,
  };


  const playBoom = () => {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();

    // Χαμηλή νότα = "βουμ"
    osc.frequency.setValueAtTime(100, ctx.currentTime);

    // Σβήνει γρήγορα = κρουστικός ήχος
    gain.gain.setValueAtTime(0.5, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.003, ctx.currentTime + 0.2);

    osc.connect(gain);
    gain.connect(ctx.destination);

    osc.start();
    osc.stop(ctx.currentTime + 0.4); // μισό δευτερόλεπτο
  };

  const unwantedicons = ["Tree", "Set"];
  // Color schemes for each data structure
  const colorSchemes = {
    HashTable: { primary: '#10b981', secondary: '#059669', accent: '#d1fae5' },
    Tree: { primary: '#3b82f6', secondary: '#2563eb', accent: '#dbeafe' },
    List: { primary: '#8b5cf6', secondary: '#7c3aed', accent: '#ede9fe' },
    Stack: { primary: '#f59e0b', secondary: '#d97706', accent: '#fef3c7' },
    Queue: { primary: '#ef4444', secondary: '#dc2626', accent: '#fecaca' },
    Graph: { primary: '#06b6d4', secondary: '#0891b2', accent: '#cffafe' },
    Array: { primary: '#ec4899', secondary: '#db2777', accent: '#fce7f3' },
    Set: { primary: '#84cc16', secondary: '#65a30d', accent: '#ecfccb' },
  };

  const scheme = colorSchemes[label] || colorSchemes.Graph;

  const getProgressColor = (value) => {
    if (value < 25) return scheme.primary + '60'; // Low progress - primary color with opacity
    if (value < 50) return scheme.primary + '80'; // Medium-low progress
    if (value < 75) return scheme.primary; // Medium-high progress
    return `linear-gradient(90deg, ${scheme.primary} 0%, ${scheme.secondary} 100%)`; // High progress - gradient
  };

  const getProgressWidth = (value) => {
    if (value > 100) return "100%";
    if (value >= 98) return "100%";
    if (value === 0) return "0%";
    const minWidth = 8;
    return Math.max(value, minWidth) + "%";
  };

  return (
    <button
      className={`ds-button`}
      onClick={onClick}
      onMouseEnter={async () => {
        setIsHovered(true);
      }}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        background: `linear-gradient(135deg, ${scheme.primary}15 0%, ${scheme.secondary}10 100%)`,
        border: `1px solid ${scheme.primary}30`,
        boxShadow: isHovered
          ? `0 0px 4px ${scheme.primary}40`
          : 'none',
        // Προαιρετικά: προσθήκη transition για ομαλή κίνηση
        transition: 'all 0.3s ease-in-out',
      }}
    >
      {/* Animated background overlay */}
      <div
        style={{
          position: 'absolute',
          inset: '0',
          background: `linear-gradient(135deg, ${scheme.primary}${isHovered ? '25' : '10'} 0%, ${scheme.secondary}${isHovered ? '20' : '08'} 100%)`,
          transition: 'all 0.4s ease',
          borderRadius: '24px',
        }}
      />

      {/* Icon container */}
      {/* Icon container */}
      <Col
        style={{
          position: 'relative',
          zIndex: 10,
          width: "60px",
          height: "60px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "16px",
          background: `linear-gradient(135deg, ${scheme.primary} 0%, ${scheme.secondary} 100%)`,
          // boxShadow: `0 8px 25px -5px ${scheme.primary}40`,
          marginBottom: "16px",
          transform: isHovered ? 'scale(1.1) rotate(5deg)' : 'scale(1) rotate(0deg)',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        }}
      >
        {/* Χρησιμοποιούμε μια κοινή τιμή για όλα, π.χ. 28px */}
        {!unwantedicons.includes(label) && (
          <FontAwesomeIcon
            icon={iconMap[label]}
            style={{
              fontSize: "28px", // Ομοιόμορφο μέγεθος για FontAwesome
              color: "white",
            }}
          />
        )}

        {label === "Tree" && (
          <img
            src={TreeIcon}
            alt="Tree Icon"
            style={{
              width: "28px",  // Ίδιο με το fontSize παραπάνω
              height: "28px",
              objectFit: "contain"
            }}
          />
        )}

        {label === "Set" && (
          <img
            src={SetIcon}
            alt="Set Icon"
            style={{
              width: "28px",  // Ίδιο με όλα τα υπόλοιπα
              height: "28px",
              objectFit: "contain"
            }}
          />
        )}
      </Col>

      {/* Label - Τώρα κεντραρισμένο */}
      <span
        className="button-label"
        style={{
          position: 'relative',
          zIndex: 10,
          fontFamily: '"Inter", "Poppins", sans-serif',
          letterSpacing: "0.5px",
          fontSize: "20px",
          fontWeight: "700",
          background: `linear-gradient(135deg, ${scheme.primary} 0%, ${scheme.secondary} 100%)`,
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          display: 'block',
          marginBottom: "16px",
          textAlign: 'center',
          width: '100%',
          opacity: isLoading ? 0 : 1,
          transition: 'opacity 0.3s ease',
        }}
      >
        {isLoading ? '' : (selLanguage ? sideBarLinks[label] : label)}
      </span>

      {/* Progress section */}
      {showProgress && (
        <Row style={{ position: 'relative', zIndex: 10, width: '100%' }}>
          {/* Progress label */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: '8px',
            width: '100%',
          }}>
            <span
              className="progress-label"
              style={{
                color: scheme.primary,
              }}>
              Progress
            </span>

          </div>

          {/* Progress bar container */}
          <div
            style={{
              width: "100%",
              height: "14px",
              borderRadius: "10px",
              position: "relative",
              backgroundColor: `${scheme.primary}20`,
              overflow: "hidden",
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {/* Progress bar fill */}
            <div
              style={{
                width: getProgressWidth(progress),
                background: typeof getProgressColor(progress) === 'string' && getProgressColor(progress).includes('gradient')
                  ? getProgressColor(progress)
                  : getProgressColor(progress),
                height: "100%",
                borderRadius: "10px",
                transition: "all 0.7s ease-out",
                boxShadow: `0 0 10px ${scheme.primary}40`,
                transform: isHovered ? 'scaleY(1.5)' : 'scaleY(1)',
                position: 'absolute',
                left: '0',
                top: '0',
              }}
            />

            {/* Progress percentage text inside bar */}
            <span style={{
              fontSize: '12px',
              fontWeight: '700',
              color: progress > 30 ? 'white' : scheme.primary,
              fontFamily: '"Inter", sans-serif',
              position: 'relative',
              zIndex: 1,
              textShadow: progress > 30 ? '0 1px 2px rgba(0,0,0,0.5)' : 'none',
              lineHeight: '1',
            }}>
              {Math.round(progress) >= 98 ? "100" : Math.round(progress)}%
            </span>
          </div>
        </Row>
      )}

      {/* Hover glow effect */}
      <div
        style={{
          position: 'absolute',
          inset: '0',
          borderRadius: '24px',
          opacity: isHovered ? '1' : '0',
          transition: 'opacity 0.3s ease',
          background: `radial-gradient(circle at center, ${scheme.primary}15 0%, transparent 70%)`,
        }}
      />

    </button>
  );
}

export default Button;